import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { Text } from 'foundations-components/components/Text';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DetailsPopoverSection({
  title,
  children
}) {
  return /*#__PURE__*/_jsx(Section, {
    paddingInlineStart: "50",
    children: /*#__PURE__*/_jsx(UIAccordionItem, {
      title: /*#__PURE__*/_jsx(Text, {
        display: "inline-block",
        as: "h6",
        "aria-level": 6,
        children: title
      }),
      defaultOpen: true,
      flush: true,
      children: children
    })
  });
}